module.exports = __webpack_public_path__ + "static/media/pla_for_cla_ext.ef6c63c4.png";